




















































































































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import {
  parseISO,
  format,
  parseJSON,
  endOfWeek,
  endOfToday,
  startOfToday
} from "date-fns"
import { find, filter } from "lodash"
import { BModalConfig } from "buefy/types/components"

import TaskCreate from "./TaskCreate.vue"
import TaskEdit from "./TaskEdit.vue"
import Pagination from "@/components/Pagination.vue"

@Component({ components: { Pagination } })
export default class TaskAssigned extends Super {
  tasks: any = null
  includeCompleted = false

  currentPage = 1
  itemsPerPage = 5

  mounted() {
    this.load()
  }

  /**
   * Load tasks from API by Event ID
   */
  load() {
    this.http
      .get(`/task?eventID=${this.eventId}`)
      .then(res => (this.tasks = res.data))
  }

  /**
   * Create a new task
   */
  openTaskCreator() {
    const config: BModalConfig = {
      parent: this,
      component: TaskCreate,
      props: {
        eventId: this.eventId
      }
    }

    this.$buefy.modal.open(config).$on("close", this.load)
  }

  /**
   * Review task details
   * @param task {any} A PV4 Task Object
   */
  openTaskEditor(task: any) {
    const config: BModalConfig = {
      parent: this,
      component: TaskEdit,
      props: {
        eventId: this.eventId,
        taskId: task.taskID
      }
    }

    this.$buefy.modal.open(config).$on("close", this.load)
  }

  /**
   * Count how many tasks are incomplete for a given userID
   * @param userID {Number}
   */
  countTasks(userID: string | number) {
    let counter = 0
    this.tasks.forEach(task => {
      if (userID == task.taskAssignerID) {
        if (task.taskStatus == 0) {
          counter++
        }
      }
    })
    return counter
  }

  /**
   * Count how many tasks due before Sunday for a given user ID
   * @param userID {Number}
   */
  tasksDueThisWeek(userID: string | number) {
    let counter = 0
    let currentDate = new Date()

    this.tasks.forEach(task => {
      let taskDate: Date = parseJSON(task.taskDueDate!)
      if (userID == task.taskAssignerID) {
        if (task.taskStatus == 0) {
          if (
            taskDate >= currentDate &&
            taskDate < endOfWeek(currentDate, { weekStartsOn: 1 })
          ) {
            counter++
          }
        }
      }
    })
    return counter
  }

  /**
   * See how many tasks are overdue for a given userID
   * @param userID {Number}
   */
  overdueTasks(userID: number | string) {
    let counter = 0

    this.tasks.forEach(task => {
      if (
        this.isTaskOverDue(task.taskDueDate) &&
        task.taskAssignerID == userID &&
        task.taskStatus == 0
      ) {
        counter++
      }
    })

    return counter
  }

  /**
   * Retrieve a task by taskID
   * @param taskID
   */
  getTask(taskID: string | number) {
    if (!this.tasks) return null
    return find(this.tasks, { taskID })
  }

  /**
   * Format the date for a nicer look
   * @param timestamp
   */
  formatTimestamp(timestamp: string) {
    return format(parseISO(timestamp), "dd MMM yyyy")
  }

  /**
   * Return boolean if the task is overdue based off task date
   * @param taskDate
   */
  isTaskOverDue(taskDate: string) {
    return (
      parseJSON(taskDate) < endOfToday() && parseJSON(taskDate) < startOfToday()
    )
  }

  /**
   * Get filtered list of tasks
   */
  get filtered() {
    if (!this.tasks) return []
    const taskAssignerID = this.account.userID

    return this.includeCompleted
      ? filter(this.tasks, { taskAssignerID })
      : filter(this.tasks, { taskAssignerID, taskStatus: 0 })
  }
}
